import * as actions from './paymentBeamType'


// Action Creators – ฟังก์ชันสำหรับสร้าง Action objects
export const setPaymentMethodEnabled = (
  method: actions.PaymentMethod, 
  enabled: boolean
): actions.SetPaymentMethodAction => ({
  type: actions.SET_PAYMENT_METHOD_ENABLED,
  payload: { method, enabled }
});

export const setAmount = (amount: number) => ({
  type: actions.SET_AMOUNT,
  payload: amount
});

export const setCurrency = (currency: string)=> ({
  type: actions.SET_CURRENCY,
  payload: currency
});

export const setReferenceId = (refId: string)=> ({
  type: actions.SET_REFERENCE_ID,
  payload: refId
});

export const setDescription = (desc: string) => ({
  type: actions.SET_DESCRIPTION,
  payload: desc
});

export const createPaymentLinkRequest = () => ({
  type: actions.CREATE_PAYMENT_LINK_REQUEST
});

export const createPaymentLinkSuccess = (
  id: string, url: string,
): actions.CreatePaymentLinkSuccessAction => ({
  type: actions.CREATE_PAYMENT_LINK_SUCCESS,
  payload: { id, url }
});

export const createPaymentLinkFailure = (
  error: string
): actions.CreatePaymentLinkFailureAction => ({
  type: actions.CREATE_PAYMENT_LINK_FAILURE,
  payload: { error }
});

export const paymentReset = () => ({
  type: actions.PAYMENT_RESET
})